import { $cms } from "@/utils/api";

export function getOmpStat() {
    return $cms().get("/manage/stat/omp");
}
